module.exports = __webpack_public_path__ + "static/media/live-event-tomorrow.88910a05.svg";